import './MessagingChannelPreview.css';
import {
  Avatar,
  ChannelPreviewUIComponentProps,
  DefaultStreamChatGenerics,
  useChatContext,
} from 'stream-chat-react';
import { getChannelName, getTimeStamp } from '../helpers';
import { clsx } from 'clsx';

type MessagingChannelPreviewProps =
  ChannelPreviewUIComponentProps<DefaultStreamChatGenerics>;

export const MessagingChannelPreview = ({
  channel,
  setActiveChannel,
  latestMessagePreview,
  unread,
}: MessagingChannelPreviewProps) => {
  const { channel: activeChannel, client } = useChatContext();

  const members = Object.values(channel.state.members).filter(
    ({ user }) => user?.id !== client.userID,
  );
  const image = members[0]?.user?.image;
  const name = members[0]?.user?.name?.charAt(0);
  const hadUnread = !!(unread && unread > 0);

  return (
    <div
      className={
        channel?.id === activeChannel?.id
          ? 'channel-preview__container selected'
          : 'channel-preview__container'
      }
      onClick={() => {
        setActiveChannel?.(channel);
      }}
    >
      <Avatar image={image} name={name} />
      <div className="channel-preview__content-wrapper">
        <div className="channel-preview__content-top">
          <p className="channel-preview__content-name">
            {getChannelName(members)}
          </p>
        </div>
        <div
          className={clsx(
            'channel-preview__content-message',
            hadUnread && 'unread',
          )}
        >
          {latestMessagePreview}
        </div>
      </div>
      <div className="flex flex-col items-center">
        {hadUnread && (
          <p className="channel-preview__unread-badge">
            {unread && unread > 9 ? '9+' : unread}
          </p>
        )}
        <p className="channel-preview__content-time">{getTimeStamp(channel)}</p>
      </div>
    </div>
  );
};
